import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let StorageAccountsOption: LazyOption = createLazyOption(
    {
        key: 'storageAccounts',
        titleStringKey: 'optionTitle_storageAccounts',
        searchTermsStringKey: 'optionTitle_storageAccounts',
        allowedOptionKeys: ['AttachmentOptions'],
    },
    lazyFullModule,
    m => m.default
);
export default StorageAccountsOption;
